import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import Moment from 'react-moment';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft, faChevronRight,
  // faTrashAlt, 
  faEdit
} from '@fortawesome/free-solid-svg-icons';
import Sidebar from 'react-sidebar';

import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import AddSalesDataFM from '../../components/SalesReport/AddSalesDataFM';

import DeleteSalesModal from '../../modal/DeleteSalesModal/DeleteSalesModal';

import SalesReportService from '../../services/SalesReportService';


class MemberSalesDetailDataTable extends Component {

  state = {
    isDeleteSalesModalOpen: false,
    recordToDelete: null,
    isLoading: false,
    sidebarOpen: false,
    sales: null
  }

  // constructor(props) {
  //   super(props);
  // }

  deleteSales = (uuid) => {
    let obj = {
      id: uuid
    }
    this.setState({ isLoading: true });
    SalesReportService.deleteSales(obj)
      .then(data => {
        this.props.reloadDataOnDelete();
        this.setState({ isDeleteSalesModalOpen: false, recordToDelete: null, isLoading: false });
      })
      .catch(e => {
        this.setState({ isLoading: false });
      })
  }

  openDeleteSalesModal = (sales) => {
    const { uuid } = sales;
    this.setState({ recordToDelete: uuid, isDeleteSalesModalOpen: true });
  }

  closeDeleteSalesModal = () => {
    this.setState({ isDeleteSalesModalOpen: false, recordToDelete: null });
  }

  openCloseSideBar = (sales) => {
    let { sidebarOpen } = this.state;
    sidebarOpen = !sidebarOpen;
    if (sidebarOpen) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
    // if (param === 'fetchData') {
    //   // this.callGetAPIs();
    // }
    if (sales === true) {
      this.props.reloadDataOnDelete();
      this.setState({ sales: null });
    } else {
      this.setState({ sales });
    }
    this.setState({ sidebarOpen });
  }

  render() {
    return (
      <div>
        <DeleteSalesModal
          show={this.state.isDeleteSalesModalOpen}
          closeModal={this.closeDeleteSalesModal}
          uuid={this.state.recordToDelete}
          deleteSales={this.deleteSales}
        >
        </DeleteSalesModal>
        <Row>
          <Col>
            <Sidebar
              sidebar={
                <AddSalesDataFM
                  openCloseSideBar={this.openCloseSideBar} isEdit={true} sales={this.state.sales} userDetail={this.props.userDetail} />
              }
              open={this.state.sidebarOpen}
              sidebarClassName="subsdiaries-sidebar"
              pullRight
              styles={{ sidebar: { background: 'white', height: '100%', width: '35%' } }}
            />
          </Col>
        </Row>
        {this.state.isLoading && <CustomSpinner></CustomSpinner>}
        <Row>
          {/* <Col className="note">* Note: Now you can update sales entries post 4th Dec'2019</Col> */}
          {this.props.fleetSalesZFM && this.props.fleetSalesZFM.sales && this.props.fleetSalesZFM.sales.length > 0 && <Col>
            <span className="Download-Full-Report pull-right" onClick={(e) => this.props.getFleetSalesReportZFM(null, null, true, this.props.queryParams.uuid)} style={{ cursor: 'pointer' }}>Download Full Report</span>
          </Col>}
        </Row>
        <Card className="c-top-15">
          <CardBody>
            <table className="table table-bordered table-responsive">
              <thead style={{ background: '#f6f6f6' }}>
                <tr>
                  <th className="sales-report-th">Sales Date</th>
                  <th colSpan="2" className="sales-report-th">Direct Sales</th>
                  {/* <th colSpan="2" className="sales-report-th">Indirect Sales</th> */}
                  <th className="sales-report-th">Description</th>
                  {/* <th colSpan="2" className="sales-report-th">Total</th> */}
                  <th className="sales-report-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td />
                  <td className="sales-report-th">TBR Qty.</td>
                  <td className="sales-report-th">TBB Qty.</td>
                  {/* <td className="sales-report-th">TBR Qty.</td>
                  <td className="sales-report-th">TBB Qty.</td> */}
                  <td className="sales-report-th"></td>
                  {/* <td className="sales-report-th">TBR</td>
                  <td className="sales-report-th">TBB</td> */}
                  <td className="sales-report-th"></td>
                  {/* <td className="sales-report-th">delete</td> */}
                </tr>

                {
                  (this.props.fleetSalesZFM.sales || []).map((sale) => (
                    <tr key={sale.uuid}>
                      <td>
                        <Moment format="DD MMM' YYYY">
                          {sale.sales_date}
                        </Moment>
                      </td>
                      <td className="sales-report-td">{sale.direct_tbr}</td>
                      <td className="sales-report-td">{sale.direct_tbb}</td>
                      <td className="sales-report-td">{sale.indirect_tbr}</td>
                      <td className="sales-report-td">{sale.indirect_tbb}</td>
                      <td className="sales-report-td">{sale.tyre_description}</td>
                      {/* <td className="sales-report-td">{sale.total_tbr}</td>
                      <td className="sales-report-td">{sale.total_tbb}</td> */}
                      <td className="sales-report-td " >
                        {/* <FontAwesomeIcon
                          className="cursor-pointer"
                          onClick={this.openDeleteSalesModal.bind(this, sale)}
                          icon={faTrashAlt}
                          color="#f7b924"
                        >
                        </FontAwesomeIcon>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
                        <FontAwesomeIcon
                          className="cursor-pointer"
                          onClick={this.openCloseSideBar.bind(this, sale)}
                          icon={faEdit}
                          color="#f7b924"
                        >
                        </FontAwesomeIcon>
                      </td>
                    </tr>
                  ))
                }

                {
                  !(this.props.fleetSalesZFM.sales || []).length &&
                  <tr>
                    <td colSpan="8" className="sales-report-td" style={{ fontSize: '14px' }}><center>No records found</center></td>
                  </tr>
                }
              </tbody>
            </table>

            {this.props.fleetSalesZFM.total_count > 10 && <div className="pull-right" style={{ display: 'flex', marginTop: '10px' }}>
              <span style={{ marginTop: '7px' }}>
                <span className="showing">Showing </span>
                <span className="showing-page">
                  {`${this.props.fleetSalesZFM.page - 1}1`}
                  -{(((this.props.fleetSalesZFM.page - 1) * 10) + (this.props.fleetSalesZFM.sales || []).length) < 10 ? '0' : ''}{(((this.props.fleetSalesZFM.page - 1) * 10) + (this.props.fleetSalesZFM.sales || []).length)}
                  &nbsp;of {this.props.fleetSalesZFM.total_count < 10 ? '0' : ''}{this.props.fleetSalesZFM.total_count}
                </span>
              </span>
              &nbsp;&nbsp;&nbsp;
              <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                breakLabel="..."
                breakClassName="break-me"
                pageCount={this.props.fleetSalesZFM.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={this.props.handlePageClick}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                pageLinkClassName="c-page"
                previousLinkClassName="c-prev"
                nextLinkClassName="c-next"
                breakLinkClassName="c-break-line"
                activeClassName="active"
                activeLinkClassName="c-page-link"
              />
            </div>}
          </CardBody>
        </Card>
      </div >
    );
  }
}

export default MemberSalesDetailDataTable;